import axios from 'axios'
import authHeader from './auth-header'

const resource = process.env.VUE_APP_API_URL + 'administrativo/pessoas'

class PessoasService {
  list (params = {}) {
    return axios.get(resource, { headers: authHeader(), params })
  }

  get (idPessoa) {
    return axios.get(`${resource}/${idPessoa}`, { headers: authHeader() })
  }

  getOptions () {
    return axios.get(`${resource}/options`, { headers: authHeader() })
  }

  searchCities (params) {
    return axios.get(`${resource}/cities`, { headers: authHeader(), params })
  }

  getAddressByCep (cep) {
    return axios.get(`${process.env.VUE_APP_API_URL}buscacep/${cep}`, { headers: authHeader() })
  }

  getAudit (idPessoa, params = {}) {
    return axios.get(`${resource}/${idPessoa}/audit`, { headers: authHeader(), params })
  }

  updateBasicData (idPessoa, data) {
    return axios.patch(`${resource}/${idPessoa}/basic-data`, data, { headers: authHeader() })
  }

  createDocument (idPessoa, data) {
    return axios.post(`${resource}/${idPessoa}/documents`, data, { headers: authHeader() })
  }

  updateDocument (idPessoa, idDocumento, data) {
    return axios.patch(`${resource}/${idPessoa}/documents/${idDocumento}`, data, { headers: authHeader() })
  }

  deleteDocument (idPessoa, idDocumento, data) {
    return axios.delete(`${resource}/${idPessoa}/documents/${idDocumento}`, { headers: authHeader(), data })
  }

  createAddress (idPessoa, data) {
    return axios.post(`${resource}/${idPessoa}/addresses`, data, { headers: authHeader() })
  }

  updateAddress (idPessoa, idEndereco, data) {
    return axios.patch(`${resource}/${idPessoa}/addresses/${idEndereco}`, data, { headers: authHeader() })
  }

  deleteAddress (idPessoa, idEndereco, data) {
    return axios.delete(`${resource}/${idPessoa}/addresses/${idEndereco}`, { headers: authHeader(), data })
  }

  createContact (idPessoa, data) {
    return axios.post(`${resource}/${idPessoa}/contacts`, data, { headers: authHeader() })
  }

  updateContact (idPessoa, idContato, data) {
    return axios.patch(`${resource}/${idPessoa}/contacts/${idContato}`, data, { headers: authHeader() })
  }

  updateStudent (idPessoa, idAluno, data) {
    return axios.patch(`${resource}/${idPessoa}/students/${idAluno}`, data, { headers: authHeader() })
  }

  changeCollaboratorStatus (idPessoa, idColaborador, data) {
    return axios.post(`${resource}/${idPessoa}/collaborators/${idColaborador}/status`, data, { headers: authHeader() })
  }

  retryCollaboratorIntegration (idPessoa, idColaborador, data) {
    return axios.post(`${resource}/${idPessoa}/collaborators/${idColaborador}/integrations/retry`, data, { headers: authHeader() })
  }

  createUser (idPessoa, data) {
    return axios.post(`${resource}/${idPessoa}/users`, data, { headers: authHeader() })
  }

  updateUser (idPessoa, idUser, data) {
    return axios.patch(`${resource}/${idPessoa}/users/${idUser}`, data, { headers: authHeader() })
  }

  changeUserStatus (idPessoa, idUser, data) {
    return axios.post(`${resource}/${idPessoa}/users/${idUser}/status`, data, { headers: authHeader() })
  }
}

export default new PessoasService()
